exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "page-item .card-meal-info {\n  position: relative; }\n  page-item .card-meal-info img {\n    height: 400px;\n    background-color: #ddd; }\n  page-item .card-meal-info img[class] {\n    width: 100%; }\n\npage-item .object-fit_cover {\n  -o-object-fit: cover;\n     object-fit: cover; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nikolay/Documents/GitHub/menu-web/src/app/pages/item/item.scss
// module id = ../../../../../src/app/pages/item/item.scss
// module chunks = main